<template>
  <div ref="appContent" class="app-content">
    <el-card>
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
          class="query-form"
      >
        <el-form-item label="合同编号：">
          <order-drop v-model="dataForm.code"></order-drop>
        </el-form-item>
        <el-form-item label="" label-width="0">
          <el-checkbox v-model="dataForm.isFuzzy">模糊搜索</el-checkbox>
        </el-form-item>
        <el-form-item label="客户：">
          <customer
              v-model="dataForm.customerId"
              @change="reload"
              :clearable="true"
          ></customer>
        </el-form-item>
        <el-form-item label="订单状态：">
          <el-select v-model="dataForm.status" size="mini">
            <el-option value="" label="全部"></el-option>
            <el-option value="10" label="待确认"></el-option>
            <el-option value="20" label="已确认"></el-option>
            <el-option value="200" label="已完成"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="pageConfig.showDetail">显示明细</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="table-bar" style="justify-content: left;margin-bottom: 0;">
        <div class="bar-item">
          <el-button
              icon="el-icon-plus"
              v-if="$hasPermission('trade:agreement:save')"
              type="primary"
              size="mini"
              @click="addOrUpdateHandle()"
          >创建外销合同
          </el-button>
          <el-button
              icon="el-icon-edit"
              v-if="$hasPermission('order:set:receipt_account')"
              type="warning"
              size="mini"
              @click="showSetReceiptAccountDialog()"
          >设置开票户头
          </el-button>

        </div>
        <div class="bar-item">
          <el-button type="warning" @click="$refs.commonUpload.init()()" v-if="$hasPermission('order:import')"
                     size="mini" icon="el-icon-upload2">订单导入
          </el-button>
        </div>
        <div class="bar-item">
          <el-button type="warning" @click="showBomUploader()" v-if="$hasPermission('order:bom:import')" size="mini"
                     icon="el-icon-upload2">
            批量导入单耗
          </el-button>
        </div>
        <div class="bar-item">
          <el-button type="danger" @click="checkOrder()" v-if="$hasPermission('order:check')" size="mini"
                     icon="el-icon-check">
            确认订单
          </el-button>
        </div>
      </div>
      <SweetTable ref="table" :selection="true" :height="maxTableHeight"
                  @row-click="rowClickHandle"
                  url="/trade/agreement/page" delete-url="/trade/agreement" :query-form="dataForm"
                  :before-table-binding="beforeTableBinding">
        <el-table-column
            prop="code"
            label="合同编号"
            header-align="center"
            align="left"
        >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showDetailDialog(scope.row)">
              {{ scope.row.code }}
            </el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-copy-document"
                @click="copyCode(scope.row.code)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="receiptAccount"
            label="开票户头"
            header-align="center"
            align="center"
            width="120"
        >
        </el-table-column>
        <el-table-column
            prop="totalAmount"
            label="总金额"
            header-align="center"
            align="center"
            width="120"
        >
        </el-table-column>
        <el-table-column
            prop="currency"
            label="交易货币"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            width="80"
        ></el-table-column>
        <el-table-column
            prop="customerName"
            label="客户名称"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            width="200"
        ></el-table-column>
        <el-table-column
            prop="businessManName"
            label="业务担当"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            width="160"
        ></el-table-column>

        <el-table-column
            prop="creatorName"
            label="操作人"
            header-align="center"
            align="center"
            width="100"
        ></el-table-column>
        <el-table-column
            prop="createDate"
            label="操作时间"
            header-align="center"
            align="center"
            width="160"
        >
        </el-table-column>
        <el-table-column
            label="状态"
            header-align="center"
            align="center"
            width="60"
        >
          <template #default="{row}">
            <OrderStatusLabel :status="row.status"></OrderStatusLabel>
          </template>
        </el-table-column>
        <el-table-column
            prop="storeFactoryName"
            label="存货工厂"
            header-align="center"
            align="center"
            :formatter="$c.companyNameFormatter"
            :show-overflow-tooltip="true"
            width="160"
        ></el-table-column>
        <el-table-column
            :label="$t('handle')"
            header-align="center"
            align="center"
            width="190"
            fixed="right"
        >
          <template slot-scope="scope">
            <div class="flex flex-wrap justify-center">
              <el-button
                  @click="edit(scope.row)"
                  type="text"
                  size="mini"
                  icon="el-icon-edit-outline"
                  v-if="$hasPermission('trade:agreement:update')&&scope.row.status == 10"
              >修改
              </el-button>
              <el-button
                  v-if="$hasPermission('order:delete')&&scope.row.status == 10"
                  style="margin-right: 5px;"
                  type="text"
                  size="mini"
                  icon="el-icon-close"
                  @click="doDel(scope.row)"
              >{{ $t('delete') }}
              </el-button>
              <el-dropdown @command="e=>{handleCommand(e,scope.row)}">
                <el-button type="text" icon="el-icon-arrow-down" size="mini">更多操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="copy" v-if="$hasPermission('order:copy')">复制合同</el-dropdown-item>
                  <el-dropdown-item command="down">下载合同</el-dropdown-item>
                  <el-dropdown-item command="changePlan" v-if="$hasPermission('trade:plan:save')">调整发货计划
                  </el-dropdown-item>
                  <el-dropdown-item command="exportDetail">导出EXCEL</el-dropdown-item>
                  <el-dropdown-item command="exportBom">导出单耗</el-dropdown-item>
                  <el-dropdown-item command="setStoreFactory">设置存货工厂</el-dropdown-item>
                  <!--                  <el-dropdown-item command="clean">品番空格清理</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </SweetTable>
    </el-card>
    <el-card v-if="pageConfig.showDetail">
      <div slot="header" class="card-header">
        <div>合同明细</div>
      </div>
      <OrderDetailTable ref="OrderDetailTable" :default-query-params="{orderId:currentId,page:1,limit:100000}"
                        :hasPage="false" :show-query="false" :show-opt-column="true"
                        :show-tool="false" :show-selection="false" :auto-load="false" :height="maxTableHeight"
                        :hide-buttons="['edit']"></OrderDetailTable>
      <!--      <OrderDetail-->
      <!--          :agreementId="currentId"-->
      <!--          ref="detailList"-->
      <!--          :maxTableHeight="maxTableHeight"-->
      <!--          :hasOpt="true"-->
      <!--          :exColumns="['cost']"-->
      <!--      ></OrderDetail>-->
    </el-card>
    <DetailDialog ref="detailDialog"></DetailDialog>
    <common-upload
        ref="commonUpload"
        @success="reload"
        uploadUrl="/erp/import/order"
        templateUrl="/static/template/合同批量导入模板.xlsx"
        title="合同批量导入"
    ></common-upload>
    <common-upload
        :data="{bomImportType:bomImportType}"
        ref="bomUpload"
        @success="getDataList"
        uploadUrl="/erp/bom/import/batch"
        templateUrl="/static/template/单耗批量导入模板2.xlsx"
        title="单耗批量导入"
        version="v2"
    >
      <div style="margin-right: 10px;">
        <el-checkbox v-model="bomImportType" true-label="append" false-label="new">
          追加导入【不会删除或修改已存在的单耗】
        </el-checkbox>
      </div>
    </common-upload>
    <copy-dialog ref="CopyDialog" @refreshDataList="getDataList"></copy-dialog>
    <ChangeStoreFactory ref="ChangeStoreFactory" @changed="getDataList"></ChangeStoreFactory>
    <SetReceiptAccountDialog ref="setReceiptAccountDialog" @changed="getDataList"></SetReceiptAccountDialog>
  </div>
</template>

<script>
import SetReceiptAccountDialog from '@/views/modules/erp/order/set-receipt-account-dialog.vue'
import ChangeStoreFactory from '@/views/modules/erp/order/change-store-factory.vue'
import OrderDetailTable from '@/components/OrderDetailTable.vue'
import CopyDialog from '@/views/modules/trade/agreement/copy-dialog'
import DetailDialog from './detail-dialog'
import OrderDetail from '@/views/modules/common/order-detail.vue'
import qs from 'qs'
import Cookies from 'js-cookie'
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: { CopyDialog, OrderDetail, DetailDialog, OrderDetailTable, ChangeStoreFactory, SetReceiptAccountDialog },
  data () {
    return {
      dateArr: [],
      currentId: '',
      statusType: {
        10: '',
        20: 'warning',
        30: 'success',
      },
      mixinViewModuleOptions: {
        getDataListURL: '/trade/agreement/page',
        getDataListIsPage: true,
        deleteURL: '/trade/agreement',
        deleteIsBatch: true,
      },
      dataForm: {
        code: '',
        customerId: '',
        beginDate: '',
        endDate: '',
        isFuzzy: false,
        status: ''
      },
      maxTableHeight: 100,
      pageConfig: {
        showDetail: true
      },
      receiptLogVisible: false,
      bomImportType: 'new'
    }
  },
  watch: {
    currentId (newVal) {
      if (newVal) {
        this.$refs.OrderDetailTable.getDataList()
      } else {
        this.$refs.OrderDetailTable.clear()
      }
    },
    'pageConfig.showDetail': {
      handler: function (newVal) {
        this.$nextTick(() => {
          let tableCount = 1
          let baseHeight = this.$refs.appContent.clientHeight -
              this.$refs.queryForm.$el.clientHeight
          if (newVal) {
            tableCount = 2
            baseHeight -= 260
          } else {
            tableCount = 1
            baseHeight -= 80
          }
          this.maxTableHeight = baseHeight / tableCount
        })
      },
      immediate: true
    },
    dateArr (newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0]
        this.dataForm.endDate = newVal[1]
      } else {
        this.dataForm.beginDate = ''
        this.dataForm.endDate = ''
      }
      this.currentId = ''
      this.reload()
    },
  },
  methods: {
    //显示户头设置弹窗
    showSetReceiptAccountDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要操作的数据')
      }
      let ids = rows.map(item => item.id)
      this.$refs.setReceiptAccountDialog.init(ids)
    },
    doDel (row) {
      this.$refs.table.doDelete(row, 'code')
    },
    checkOrder () {
      let dataList = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error(`请选择订单`)
      }
      this.$confirm(`已选择【${dataList.length}】个订单,确认订单后将不能进行修改和删除,是否继续操作?`).then(() => {
        this.$api.post(`/erp/order/check`, { ids: dataList.map(o => o.id) }).then(res => {
          this.getDataList()
          this.clearSelection()
        })
      })
    },
    handleCommand (e, row) {
      if (e == 'copy') {
        this.$refs.CopyDialog.init(row.id)
        this.copy(row)
      } else if (e == 'down') {
        this.download(row)
      } else if (e == 'changePlan') {
        this.$router.push(`/trade/agreement/plan/save?agreementId=${row.id}`)
      } else if (e == '下载发票') {
        this.downReceipt(row)
      } else if (e === 'exportDetail') {
        var params = qs.stringify({
          token: Cookies.get('token'),
          id: row.id,
        })
        window.location.href = `${window.SITE_CONFIG['apiURL']}/trade/agreement/export/detail?${params}`
      } else if (e == 'exportBom') {
        this.$export(`/erp/bom/export`, { orderId: row.id })
      } else if (e == 'clean') {
        this.$api.get(`/trade/agreement/clean/product?orderId=${row.id}`)
      } else if (e == 'setStoreFactory') {
        this.$refs.ChangeStoreFactory.init(row.id)
      }
    },
    //单耗导入开始
    showBomUploader () {
      this.$refs.bomUpload.init()
    },
    copyCode (code) {
      this.$copyText(code)
          .then(() => {
            this.$message.success(`${code}已成功复制到剪切板`)
          })
          .catch(() => {
            this.$message.error(`${code}复制失败`)
          })
    },
    edit (row) {
      this.$router.push(`/trade/agreement/save?id=${row.id}`)
    },
    download (row) {
      var params = qs.stringify({
        token: Cookies.get('token'),
        id: row.id,
      })
      window.location.href = `${window.SITE_CONFIG['apiURL']}/trade/agreement/export?${params}`
    },
    downReceipt (row) {
      var params = qs.stringify({
        token: Cookies.get('token'),
        id: row.id,
      })
      window.location.href = `${window.SITE_CONFIG['apiURL']}/trade/order/export/nitori?${params}`
    },
    beforeTableBinding (dataList) {
      if (dataList && dataList.length > 0) {
        this.rowClickHandle(dataList[0])
      } else {
        this.currentId = ''
      }
    },
    addOrUpdateHandle (row) {
      let id = ''
      if (row) {
        id = row.id
      }
      this.$router.push(`/trade/agreement/save?id=${id}`)
    },
    showDetailDialog (row) {
      this.$refs.detailDialog.id = row.id
      this.$refs.detailDialog.init()
    },

    rowClickHandle (row) {
      if (!row) {
        this.currentId = ''
        return
      }
      if (this.currentId === row.id) {
        this.$refs.OrderDetailTable.reload()
        return
      }
      this.currentId = row.id
    },
  },
}
</script>
